import {
    countEquipmentAssignments,
    countWorkerAssignments,
    formatAssignmentLines,
    formatCreatedAtLabel,
    formatJobNotesText,
    formatReportStatusLabel,
    formatRequirementsLines,
    formatScheduleEndLabel,
    formatScheduleStartLabel,
    formatSitesText,
} from './dispatch-report-fields'
import type {DispatchReport} from './schemas'

const UTF8_BOM = '\uFEFF'
const CSV_QUANTITY_SEPARATOR = 'x'

const CSV_HEADERS = [
    'Status',
    'Created',
    'Job',
    'Start',
    'End',
    'PO',
    'Customer',
    'Sites',
    'Workers',
    'Equipment',
    'Requirements',
    'Assignments',
    'Order notes',
    'Job notes',
] as const

function escapeCsvField(value: string) {
    if (/[",\n\r]/.test(value)) {
        return `"${value.replaceAll('"', '""')}"`
    }
    return value
}

function joinFieldLines(lines: string[]) {
    return lines.join('; ')
}

export function buildDispatchReportCsv(report: DispatchReport) {
    const rows = report.jobs.map((job) =>
        [
            formatReportStatusLabel(job.status),
            formatCreatedAtLabel(job.createdAt),
            job.displayId,
            formatScheduleStartLabel(job.startDate, job.startTime),
            formatScheduleEndLabel(job.endDate),
            job.poNumber ?? '',
            job.customerName,
            formatSitesText(job),
            String(countWorkerAssignments(job)),
            String(countEquipmentAssignments(job)),
            joinFieldLines(formatRequirementsLines(job, CSV_QUANTITY_SEPARATOR)),
            joinFieldLines(formatAssignmentLines(job, CSV_QUANTITY_SEPARATOR)),
            job.projectNotes ?? '',
            formatJobNotesText(job),
        ].map(escapeCsvField),
    )

    const csvBody = [CSV_HEADERS.join(','), ...rows.map((row) => row.join(','))].join('\n')
    return `${UTF8_BOM}${csvBody}`
}

export function dispatchReportCsvFilename(reportDate: string) {
    return `dispatch-report-${reportDate}.csv`
}

export function downloadDispatchReportCsv(report: DispatchReport) {
    const csv = buildDispatchReportCsv(report)
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8'})
    const url = URL.createObjectURL(blob)
    const anchor = document.createElement('a')
    anchor.href = url
    anchor.download = dispatchReportCsvFilename(report.reportDate)
    anchor.click()
    URL.revokeObjectURL(url)
}
